<p-panel header="{{ categoryName  | translate }}">
	<div class="grid pt-2">
		<div [ngClass]="col12Responsive()" *ngIf="!isVirtual">
			<app-retry-init></app-retry-init>
		</div>
		<div [ngClass]="col12Responsive()"
			*ngIf="device !== undefined && supportSignalLevel && device.CurrentlyOwned && !notAvailableSignalLevel()">
			<app-signal-level></app-signal-level>
		</div>
		<div [ngClass]="col12Responsive()" *ngIf="device !== undefined && device.CurrentlyOwned && hasDatetime()">
			<app-datetime-device></app-datetime-device>
		</div>
		<div [ngClass]="col12Responsive()" *ngIf="hasProgress()">
			<app-device-state-progress></app-device-state-progress>
		</div>
		<div [ngClass]="col12Responsive()" *ngIf="hasPeripheralNumber()">
			<div class="flex justify-content-between flex-wrap card">
				<div class="flex align-items-center justify-content-start font-bold border-round m-2">{{ 'CRP_ADDRESS' |
					translate }}</div>
				<div class="flex align-items-center justify-content-end font-bold border-round m-2">{{ peripheralNumber }}
				</div>
			</div>
		</div>
		<div [ngClass]="col12Responsive()" *ngIf="hasSerial()">
			<div class="flex justify-content-between flex-wrap card">
				<div class="flex align-items-center justify-content-start font-bold border-round m-2">{{ 'SERIAL_NUMBER' |
					translate }}</div>
				<div class="flex align-items-center justify-content-end font-bold border-round m-2">{{ serial }}</div>
			</div>
		</div>
		<div [ngClass]="col12Responsive()" *ngIf="hasKeycode()">
			<div class="flex justify-content-between flex-wrap card">
				<div class="flex align-items-center justify-content-start font-bold border-round m-2">{{ 'KEYCODE' |
					translate }}</div>
				<div class="flex align-items-center justify-content-end font-bold border-round m-2">{{ keycode }}</div>
			</div>
		</div>
		<div [ngClass]="col12Responsive()" *ngIf="hasProductType()">
			<div class="flex justify-content-between flex-wrap card">
				<div class="flex align-items-center justify-content-start font-bold border-round m-2">{{ 'PRODUCT_TYPE' |
					translate }}</div>
				<div class="flex align-items-center justify-content-end font-bold border-round m-2">{{ productType }}</div>
			</div>
		</div>
		<div [ngClass]="col12Responsive()" *ngIf="hasBoardType()">
			<div class="flex justify-content-between flex-wrap card">
				<div class="flex align-items-center justify-content-start font-bold border-round m-2">{{ 'BOARD_TYPE' |
					translate }}</div>
				<div class="flex align-items-center justify-content-end font-bold border-round m-2">{{ boardType }}</div>
			</div>
		</div>
		<div [ngClass]="col12Responsive()" *ngIf="hasProductName()">
			<div class="flex justify-content-between flex-wrap card">
				<div class="flex align-items-center justify-content-start font-bold border-round m-2">{{ 'PRODUCT_NAME' |
					translate }}</div>
				<div class="flex align-items-center justify-content-end font-bold border-round m-2">{{ productName }}</div>
			</div>
		</div>
		<div [ngClass]="col12Responsive()" *ngIf="hasHwVersion()">
			<div class="flex justify-content-between flex-wrap card">
				<div class="flex align-items-center justify-content-start font-bold border-round m-2">{{ 'HW_VERSION' |
					translate }}</div>
				<div class="flex align-items-center justify-content-end font-bold border-round m-2">{{ hwVersion }}</div>
			</div>
		</div>
		<div [ngClass]="col12Responsive()" *ngIf="hasFwVersion()">
			<div *ngIf="!isAutomation" class="flex justify-content-between flex-wrap card" [ngClass]="getColorCard()">
				<div class="flex align-items-center justify-content-start font-bold border-round m-2">
					{{ hasUpdateFirmware() ? ('FW_VERSION_UPDATE' |translate) : ('FW_VERSION' | translate) }}</div>
				<div class="flex align-items-center justify-content-end font-bold border-round">
					<!-- <p-progressSpinner *ngIf="updatingFirmware" ariaLabel="loading" styleClass="w-4rem h-2rem"
						strokeWidth="4"></p-progressSpinner> --> <!-- !! TODO -->
					<p-button *ngIf="releaseNoteAvailable" class="pr-2" pTooltip="{{ 'RELEASE_NOTE_DEVICE' | translate }}"
						tooltipPosition="bottom" icon="pi cm-info" size="large" (click)="showReleaseNote()" [rounded]="false"
						[text]="true" severity="primary">
					</p-button>
					<p-button *ngIf="firmwareUpdates.length > 0" class="pr-2" pTooltip="{{ 'UPDATE_FIRWARE' | translate }}"
						tooltipPosition="bottom" icon="pi cm-update-firmware" size="large" (click)="clickUpdateFirmware()"
						[rounded]="false" [text]="true" severity="danger" [disabled]="offline()  || onFirmwareUpdate()">
					</p-button> <!-- *ngIf="!updatingFirmware" --> <!-- !! TODO -->
					<div class="pb-1 p-0">{{ fwVersion }}</div> <!-- *ngIf="!updatingFirmware" --> <!-- !! TODO -->
				</div>
			</div>
			<div *ngIf="isAutomation" class="flex justify-content-between flex-wrap card">
				<div class="flex align-items-center justify-content-start font-bold border-round m-2">
					{{ hasUpdateFirmware() ? ('FW_VERSION_UPDATE' |translate ) : ('FW_VERSION' | translate ) }}</div>
				<div class="flex align-items-center justify-content-end font-bold border-round">
					<p-progressSpinner *ngIf="updatingFirmware" ariaLabel="loading" styleClass="w-4rem h-2rem"
						strokeWidth="4"></p-progressSpinner>
					<p-button *ngIf="releaseNoteAvailable" class="pr-2" pTooltip="{{'RELEASE_NOTE_DEVICE' | translate }}"
						tooltipPosition="bottom" icon="pi cm-info" size="large" (click)="showReleaseNote()" [rounded]="false"
						[text]="true" severity="primary">
					</p-button>
					<p-button *ngIf="!updatingFirmware" class="pr-2" pTooltip="{{'UPDATE_VERSION_FW' | translate }}"
						tooltipPosition="bottom" icon="pi cm-reload" size="large" (click)="buttonFw()" [rounded]="false"
						[text]="true" severity="primary" [disabled]="!deviceConfiguredOnline()">
					</p-button>
					<div *ngIf="!updatingFirmware" class="pb-1 p-0">{{ fwVersion }}</div>
				</div>
			</div>
		</div>
		<div [ngClass]="col12Responsive()" *ngIf="hasError()">
			<div class="flex justify-content-between flex-wrap card">
				<div class="flex align-items-center justify-content-start font-bold border-round m-2">{{ 'ERROR' | translate
					}}</div>
				<div class="flex align-items-center justify-content-end font-bold border-round m-2">{{ deviceError }}</div>
			</div>
		</div>
		<div [ngClass]="col12Responsive()" *ngIf="hasManeuvers()">
			<div class="flex justify-content-between flex-wrap card">
				<div class="flex align-items-center justify-content-start font-bold border-round m-2">{{ 'MANEUVERS' |
					translate }}</div>
				<div class="flex align-items-center justify-content-end font-bold border-round m-2">{{ maneuvers }}</div>
			</div>
		</div>
		<div [ngClass]="col12Responsive()" *ngIf="hasLastSeen()">
			<div class="flex justify-content-between flex-wrap card">
				<div class="flex align-items-center justify-content-start font-bold border-round m-2">{{ 'DATE_LAST_EVENT' |
					translate }}</div>
				<div class="flex align-items-center justify-content-end font-bold border-round m-2">{{ lastSeen |
					localizedDate:'medium' }}</div>
			</div>
		</div>
		<div [ngClass]="col12Responsive()" *ngIf="hasImei()">
			<div class="flex justify-content-between flex-wrap card">
				<div class="flex align-items-center justify-content-start font-bold border-round m-2">{{ 'IMEI_CODE' |
					translate }}</div>
				<div class="flex align-items-center justify-content-end font-bold border-round m-2">{{ imeiCode }}</div>
			</div>
		</div>
	</div>
</p-panel>